import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-amber-500/15',
    borderColor: 'border-amber-500/40',
    textColor: 'text-amber-300',
    emoji: '📘',
    title: 'Fundamentos del Apostador',
    subtitle: 'El lenguaje del dinero en el fútbol',
    desc: 'Lo que el 90% de los apostadores nunca aprendió. Cómo funciona el negocio de las apuestas desde adentro, qué es el margen del bookmaker, cómo leer una cuota y calcular su probabilidad implícita, todos los mercados explicados sin tecnicismos (Over/Under, BTTS, Hándicap, Corners, Cash Out), apuestas simples vs. combinadas con matemáticas reales, y los 10 errores fatales que destruyen el bankroll del principiante.'
  }, {
    id: 2,
    lightColor: 'bg-yellow-500/15',
    borderColor: 'border-yellow-500/40',
    textColor: 'text-yellow-300',
    emoji: '📘',
    title: 'Dónde hacer Apuestas',
    subtitle: 'La infraestructura estratégica del apostador',
    desc: 'No todas las plataformas son iguales. Los 8 criterios para elegir un bookmaker con criterio objetivo, cómo verificar la licencia de una plataforma en 5 minutos, métodos de pago y velocidad de retiro, cómo leer un bono de bienvenida sin caer en trampas, apps móviles y experiencia de usuario. Tabla comparativa premium de 10 plataformas con disponibilidad en Argentina — Mercado Pago, transferencias y billeteras digitales incluidas.'
  }, {
    id: 3,
    lightColor: 'bg-orange-500/15',
    borderColor: 'border-orange-500/40',
    textColor: 'text-orange-300',
    emoji: '📘',
    title: 'Cómo Estudiar Partidos',
    subtitle: 'El sistema de análisis en 6 capas',
    desc: 'El tomo más importante del sistema. El sistema completo de análisis en 6 capas, cómo leer la forma reciente más allá del resultado superficial, lesiones y disponibilidad — el factor más subestimado, xG simplificado para apostar sin ser estadístico, estilos de juego y lectura táctica simple, cómo detectar value en cualquier partido, y ejemplos reales aplicados al Mundial.'
  }, {
    id: 4,
    lightColor: 'bg-red-500/15',
    borderColor: 'border-red-500/40',
    textColor: 'text-red-300',
    emoji: '📘',
    title: 'Estrategias para el Mundial',
    subtitle: 'Del análisis a la acción concreta',
    desc: 'Los 4 perfiles estratégicos del apostador y las estrategias compatibles con cada uno. Estrategias conservadoras, agresivas y de mercados alternativos. Over/Under, Corners, BTTS y Goleadores como estrategias sistemáticas. Estrategias específicas para la fase de grupos vs. eliminatorias. Cuándo NO apostar — la decisión más rentable que nadie registra.'
  }, {
    id: 5,
    lightColor: 'bg-purple-500/15',
    borderColor: 'border-purple-500/40',
    textColor: 'text-purple-300',
    emoji: '📘',
    title: 'Gestión de Dinero y Disciplina',
    subtitle: 'El sistema que separa al inteligente del impulsivo',
    desc: 'El tomo que más autoridad le da al sistema. Qué es el bankroll y cómo construirlo correctamente. Los 4 sistemas de gestión de stakes con matemáticas reales. El tilt — qué es, cómo se instala y cómo se destruye. Control emocional como habilidad entrenable. Cómo evitar perseguir pérdidas. El registro de apuestas como herramienta de mejora continua.'
  }, {
    id: 6,
    lightColor: 'bg-amber-400/20',
    borderColor: 'border-amber-400/50',
    textColor: 'text-amber-300',
    emoji: '⭐',
    title: 'Especial Mundial 2026',
    subtitle: 'El mapa completo del torneo',
    desc: 'El nuevo formato de 48 equipos y sus implicancias estratégicas. Las 16 sedes — altitud, clima y factor logístico. Las selecciones favoritas con sus mercados más predecibles. 15 tendencias históricas del Mundial con base estadística. Cómo apostar en el Mundial vs. en la liga. Capítulo especial sobre la Argentina — sus mercados más predecibles, su estilo y la gestión emocional de apostar al equipo que más amás.'
  }];
  return <section className="py-20 bg-zinc-900" data-id="element-322">
      <div className="container mx-auto px-4" data-id="element-323">
        <div className="text-center mb-16" data-id="element-324">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-400/15 text-amber-300 border border-amber-400/30 font-bold mb-6 text-[16px]" data-id="element-325">
            🏆 MASTERPACK APUESTAS MUNDIAL
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-326">
            6 Tomos + 4 Bonus
          </h2>
          <p className="text-zinc-200 font-medium text-[16px]" data-id="element-327">
            Del instinto al análisis. Del caos al sistema. 400+ páginas — Todo
            resuelto.
          </p>
          <p className="text-amber-300 font-medium text-sm mt-2" data-id="element-328">
            📚 Un tomo por cada dimensión del sistema
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-329">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-amber-900/40 bg-black/70 overflow-hidden shadow-lg hover:shadow-xl hover:border-amber-700/60 transition-all flex flex-col h-full" data-id="element-330">
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-331">
                <div className="text-2xl" data-id="element-332">{tomo.emoji}</div>
                <div data-id="element-333">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-334">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-335">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-336">
                <p className="font-semibold text-amber-200 mb-3 pb-3 border-b border-amber-900/30" data-id="element-337">
                  {tomo.subtitle}
                </p>
                <p className="text-zinc-200 text-sm leading-relaxed" data-id="element-338">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}